import { useEffect } from 'react';
import { useFooterContext } from '../contexts/FooterContext';
import { IFooterState } from '../types/shell';

// Important: config object MUST be wrapped in useMemo for stability of reference.
// `anchorRef` (also stable — a ref object's identity never changes across renders) is the
// page's "selection section" anchor for the scroll-guidance state machine.
export const useFooter = (config: IFooterState, anchorRef?: React.RefObject<HTMLElement>) => {
  const { setFooterState, clearFooterState, setAnchorRef } = useFooterContext();

  useEffect(() => {
    setFooterState(config);
  }, [config, setFooterState]);

  useEffect(() => {
    setAnchorRef(anchorRef);
  }, [anchorRef, setAnchorRef]);

  useEffect(() => {
    return () => {
      clearFooterState();
      setAnchorRef(undefined);
    };
  }, [clearFooterState, setAnchorRef]);
};
